import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from "@angular/router";
import {OktaAuth} from "@okta/okta-auth-js";
import {AuthService} from "../auth/auth.service";
import {filter, take} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class OnboardGuardService implements CanActivate {

  constructor(private oktaAuth: OktaAuth, private authService: AuthService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

    const validationComplete : Promise<boolean> = new Promise(async (resolve, reject) => {
      let foundMatch : boolean = false;
      if (await this.authService.isLoggedIn()) {
        //  Make sure the cached Role is populated - in the case of a login/callback it will not be.
        let accessRouteList: string[] = new Array();
        // Store the Routes that are allowed per the Role + Permissions of this User in Okta.
        this.authService.role.pipe(filter(roleValue => !!roleValue.roleId), take(1)).subscribe(role => {
          role.rolePermission?.forEach((rolePermission) => {
            if (rolePermission.permission?.enabled) {
              if (rolePermission.permission?.route != null && rolePermission.permission?.route.trim() !== '') {
                accessRouteList?.push(rolePermission.permission?.route!);
              }
            }
          });

          let urlString = route.url.toString().replace(',', '/').replace(',', '/').trim();

          let uuIdPresent : boolean = false;
          let numericIdPresent : boolean = false;
          if(urlString.includes('/')) {
            const lastParameter = urlString.substring((urlString.lastIndexOf('/') + 1), (urlString.length));
            const regexExpForUuId = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
            uuIdPresent = regexExpForUuId.test(lastParameter);
            if(Number(lastParameter.trim()) > 0) numericIdPresent = true;
          }

          accessRouteList.forEach(value => {
            value = value.replace('{uuId}', '');
            if (urlString === value.trim()) foundMatch = true;
            // Dynamic URL Use Case - Application Detail View
            else if(uuIdPresent && urlString.startsWith(value.trim())) foundMatch = true;
            else if(numericIdPresent && urlString.startsWith(value.trim())) foundMatch = true;
          });
          resolve(foundMatch);
        });
      } else {
        try {
          await this.oktaAuth.signInWithRedirect({originalUri: '/'});
        } catch (err) {
          console.error(err);
        }
      }
    });
    return validationComplete;
  }
}
